import _asyncToGenerator from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u82F1\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.slice.js";
import "regenerator-runtime/runtime.js";
import { ref, onMounted } from "vue";
import { enGetCompanyInfo_url } from "@/api"; //引入发送请求获取数据的方法

export default {
  components: {},
  name: "founder",
  setup: function setup() {
    // require('@/pages/index/images/banner1.png')
    var items = [{
      id: 1,
      text: "Item 1",
      iconImg: require("@/pages/aboutUs/images/about_icon_01.png")
    }, {
      id: 2,
      text: "Item 2",
      iconImg: require("@/pages/aboutUs/images/about_icon_02.png")
    }, {
      id: 3,
      text: "Item 3",
      iconImg: require("@/pages/aboutUs/images/about_icon_03.png")
    }];
    onMounted(function () {
      getCompanyInfo();
    });
    var companyInfo = ref({});

    var getCompanyInfo = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return enGetCompanyInfo_url();

              case 2:
                res = _context.sent;
                companyInfo.value = res.data.companyInfo; // console.log(res, '公司信息')

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getCompanyInfo() {
        return _ref.apply(this, arguments);
      };
    }();

    var displayedItems = ref(items.slice(0, 2));
    var showMoreFund = ref(false);
    var showMoreFlag = ref(false); //控制按钮

    var toggleMore = function toggleMore() {
      showMoreFund.value = true;
    };

    var activeNames = ref(-1);

    var retract = function retract(name) {
      showMoreFund.value = false;
      activeNames.value = -1; //  hiddenIndex.value = -1d
      // console.log(activeNames.value,'看看是什么');
      // activeNames.value = activeNames.value.filter(n => n !== name);
    };

    return {
      showMoreFund: showMoreFund,
      showMoreFlag: showMoreFlag,
      toggleMore: toggleMore,
      retract: retract,
      activeNames: activeNames,
      companyInfo: companyInfo
    };
  }
};